import useEffectOnce from './useEffectOnce';
var useMount = function (fn) {
    useEffectOnce(function () {
        fn();
    });
};
export default useMount;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/useMount.js
// module id = null
// module chunks = 